import React, { useState } from 'react'

import { Card, CardContent, CardHeader, Grid, Tab, Tabs } from '@mui/material'

import {
  CreateNewUserInterviewSegmentTool,
  SegmentBrowser,
  UpdateUxAttributeTool,
} from './CustomerioUserInterview'
import {
  EnterpriseBulkLicenseForm,
  EnterpriseBasicSetupForm,
  EnterpriseSSOForm,
  UpgradeToSSOForm,
  UpdatePlanExpirationDateForm,
  UpgradeToBasicSetupForm,
} from './EnterprisePlan'
import ImpactMetricsDebug from './ImpactMetricsDebug'
import MetricsDataUpload from './MetricsDataUpload'
import { NotificationPreview, RecommendationCardPreview } from './Previewer'
import RecommendationDataBrowser from './RecommendationDataBrowser'
import { CreateTenantOAuthConfigForm, CreateTenantForm } from './Tenant'
import UpdateTenantEmailConfigForm from './Tenant/UpdateTenantEmailConfigForm'
import styles from './Tools.module.scss'

function TabPanel({
  children,
  value,
  index,
}: {
  children: React.ReactNode
  value: number
  index: number
}) {
  return (
    <div
      className={styles.tabPanel}
      role="tabpanel"
      hidden={value !== index}
      id={`tools-tabpanel-${index}`}
      aria-labelledby={`tools-tab-${index}`}
    >
      {value === index && children}
    </div>
  )
}

function TabSection({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) {
  return (
    <Card className={styles.tabSection}>
      <CardHeader title={title} className={styles.sectionTitle} />
      <CardContent>{children}</CardContent>
    </Card>
  )
}

function a11yProps(index: number) {
  return {
    id: `tools-tab-${index}`,
    'aria-controls': `tools-tabpanel-${index}`,
  }
}

export default function Tools() {
  const [value, setValue] = useState(0)

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Grid container spacing={1}>
      <p className={styles.pageDescription}>
        A collection of tools to support Goby development and administration.
      </p>

      <Grid size={{ xs: 12 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Tools tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Previewer" {...a11yProps(0)} />
          <Tab label="Data Upload" {...a11yProps(1)} />
          <Tab label="Impact Metrics" {...a11yProps(2)} />
          <Tab label="Recommendation Data" {...a11yProps(3)} />
          <Tab label="Customer.io" {...a11yProps(4)} />
          <Tab label="Enterprise Plan" {...a11yProps(5)} />
          <Tab label="Tenant" {...a11yProps(6)} />
        </Tabs>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <TabPanel value={value} index={0}>
          <TabSection title="Notification Previewer">
            <NotificationPreview />
          </TabSection>
          <TabSection title="Recommendation Card Previewer">
            <RecommendationCardPreview />
          </TabSection>
        </TabPanel>

        <TabPanel value={value} index={1}>
          <TabSection title="Data upload tool">
            <MetricsDataUpload />
          </TabSection>
        </TabPanel>

        <TabPanel value={value} index={2}>
          <TabSection title="Impact Metrics">
            <ImpactMetricsDebug userId={null} />
          </TabSection>
        </TabPanel>

        <TabPanel value={value} index={3}>
          <TabSection title="Recommendation Data Browser">
            <RecommendationDataBrowser />
          </TabSection>
        </TabPanel>

        <TabPanel value={value} index={4}>
          <TabSection title="User Interview Recruitment Customer.io Tools">
            <CreateNewUserInterviewSegmentTool csrfToken="" />
            <UpdateUxAttributeTool csrfToken="" />
            <SegmentBrowser />
          </TabSection>
        </TabPanel>

        <TabPanel value={value} index={5}>
          <TabSection title="New enterprise plan: Bulk license">
            <EnterpriseBulkLicenseForm />
          </TabSection>
          <TabSection title="New enterprise plan: Basic Setup">
            <EnterpriseBasicSetupForm />
          </TabSection>
          <TabSection title="New enterprise plan: SSO Integration">
            <EnterpriseSSOForm />
          </TabSection>
          <TabSection title="Upgrade enterprise plan: to SSO Integration">
            <UpgradeToSSOForm />
          </TabSection>
          <TabSection title="Upgrade enterprise plan: to Basic Setup">
            <UpgradeToBasicSetupForm />
          </TabSection>
          <TabSection title="Renew enterprise plan: Update expiration date">
            <UpdatePlanExpirationDateForm />
          </TabSection>
        </TabPanel>

        <TabPanel value={value} index={6}>
          <TabSection title="Create Tenant">
            <CreateTenantForm />
          </TabSection>

          <TabSection title="Update Tenant Email Config">
            <UpdateTenantEmailConfigForm />
          </TabSection>

          <TabSection title="Create Tenant OAuth Config">
            <CreateTenantOAuthConfigForm />
          </TabSection>
        </TabPanel>
      </Grid>
    </Grid>
  )
}
